import { render, staticRenderFns } from "./ConfirmOperations.vue?vue&type=template&id=0b5e6636&"
import script from "./ConfirmOperations.vue?vue&type=script&lang=js&"
export * from "./ConfirmOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports